import React, { useState, useEffect } from "react";
import InstructionsModal from "../InstructionsModal/InstructionsModal";
import './style.css';
import { InstructionsIcon } from "../../assets/icons/icons";

export default function EvaluationInstructions() {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <>
            {/* <div className="journal-entry">
                <h3>Evaluation Instructions</h3>
                <p>Click the button below to learn more about evaluations</p>
                <div className="reflection-art-container">
                    <button onClick={toggleModal}>Learn More</button>
                </div>
                <InstructionsModal
                    isOpen={isModalOpen}
                    closeModal={toggleModal}
                />
            </div> */}
            <div className="action-tile">
                <div className="action-container">
                    <div className="action-title-container">
                        <h3>Evaluation Instructions</h3>
                        <p>Click the button below to learn more about evaluations</p>
                    </div>
                    <InstructionsIcon className='action-icon-alt'/>
                </div>
                <div className="action-btn-container">
                    <button className="action-btn" onClick={toggleModal}>Learn More</button>
                </div>
                <InstructionsModal
                    isOpen={isModalOpen}
                    closeModal={toggleModal}
                />
            </div>
        </>
    );
}
